(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rmpc-choose-pc"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rmpc-build-comparison')) {
  customElements.define('rmpc-build-comparison', class extends HTMLElement {
    connectedCallback() {
      const control = this.querySelector('.rmpc-sort');
      const select = this.querySelector('select');
      const list = this.querySelector('[data-build-list]');
      if (!control || !select || !list || this.ready) return;
      this.ready = true;
      control.hidden = false;
      select.addEventListener('change', () => {
        const rows = [...list.querySelectorAll('[data-price]')];
        rows.sort((a,b) => (Number(a.dataset.price) - Number(b.dataset.price)) * (select.value === 'desc' ? -1 : 1));
        rows.forEach(row => list.append(row));
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
